import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import IconButton from '@material-ui/core/IconButton';
import Autosuggest from 'react-autosuggest';
import DatePicker from 'react-datepicker';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import UserIcon from '@material-ui/icons/SentimentVerySatisfied';
import LeadIcon from '@material-ui/icons/ImportExport';
import CommentIcon from '@material-ui/icons/Comment';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import moment from 'moment';
import _ from 'lodash';

import { CSVLink } from 'react-csv';

import Condition from '../containers/Condition';

import '../styles/Analytics.css';
import 'react-datepicker/dist/react-datepicker.css';
import PieChartAnalytics from '../containers/PieChartAnalytics';
import DataList from './DataList';
import EventAnalytics from '../containers/EventAnalytics';

const styles = theme => ({
  tableList: {
    height: '205px',
  },
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
  },
  paperTable: {
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
  },
  paperPieChart: {
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
    padding: '15px',
    marginTop: '8px',
  },
  paperAdsComment: {
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
    padding: '15px',
    margin: '5px',
    width: '392.42px',
    height: '250px',
    overflow: 'auto',
  },
  paperBarChart: {
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
  },
  paperQuestion: {
    color: theme.palette.text.secondary,
    position: 'absolute',
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 999,
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    margin: 0,
    marginLeft: '10px',
  },
  subtitle: {
    ...theme.Typography,
    color: '#044591',
    marginTop: '10px',
    marginLeft: '18px',
  },
  chartTitle: {
    ...theme.Typography,
    color: '#044591',
  },
  questionTitle: {
    ...theme.Typography,
    color: '#044591',
    textAlign: 'center',
  },
  headerQuestionIcon: {
    marginRight: '15px',
  },
  headerQuestionTitle: {
    display: 'flex',
    color: '#044591',
    marginTop: '15px',
    justifyContent: 'center',
  },
  button: {
    height: 'auto',
    width: '150px',
    margin: '25px',
  },
  deleteButton: {
    margin: 'auto',
    padding: '1px',
    marginRight: '3px',
  },
  containerFieldFilter: {
    display: 'flex',
    alignItems: 'center',
    border: '1px',
    borderStyle: 'dotted',
    marginLeft: '18px',
    marginBottom: '10px',
  },
  selectOperatorContainer: {
    padding: '25px',
  },
  selectValueContainer: {
    paddingLeft: '25px',
    paddingTop: '25px',
  },
  dateFilter: {
    width: 'inherit',
    height: '30px',
    padding: '10px 20px',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: '300',
    fontSize: '16px',
    border: '1px solid #aaa',
    borderRadius: '4px',
    margin: '5px 20px 5px 20px',
  },
  calendar: {
    zIndex: 999,
  },
  teamInput: {
    margin: '15px',
    maxWidth: '100px',
  },
  avatar: {
    marginRight: 10,
    color: '#fff',
  },
  card: {
    width: 'fit-content',
    marginRight: '4px',
    marginLeft: '4px',
    marginTop: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  cardDataInside: {
    display: 'flex',
    width: '150px',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  gridCards: {
    display: 'flex',
  },
  displayName: {
    display: 'flex',
    alignItems: 'center',
  },
  formControl: {
    minWidth: 120,
  },
  containerFormQuestion: {
    display: 'flex',
    flexDirection: 'column',
    margin: '25px',
  },
  pieContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '5px',
  },
  inlineComment: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  dateComment: {
    color: 'gray',
    paddingLeft: '5px',
  },
  userComment: {
    fontWeight: 'bold',
  },
  adsContainer: {
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: '100%',
  },
  adsData: {
    height: '100%',
    justifyContent: 'space-around',
    display: 'flex',
    flexDirection: 'column',
  },
  headerAnalytics: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  btnReport: {
    textDecoration: 'none',
    margin: '0 0 20px 20px',
  },
  filterDate: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  pickerDate: {
    marginLeft: 25,
  },
  sup: {
    fontSize: '50%',
    top: '-1em',
  },
});

const CardData = ({ classes, label, data, AvatarIcon, color, hide }) => {
  if (hide) {
    return null;
  } else {
    return (
      <Card className={classes.card} elevation={0}>
        <CardContent>
          <div className={classes.cardDataInside}>
            <div>
              <Avatar className={classes.avatar} style={{ backgroundColor: color }}>
                {typeof AvatarIcon !== 'string' ? <AvatarIcon /> : AvatarIcon}
              </Avatar>
            </div>
            <div>
              <Typography variant="h5">{data}</Typography>
              <Typography variant="caption" color="textSecondary">
                {label}
              </Typography>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }
};

const Comment = ({ classes, question }) => {
  const { questionTitle, listComments } = question;
  const listCommentsSize = _.get(listComments, 'length', 0);

  return (
    <Grid item className={classes.pieContainer}>
      <Paper className={classes.paperAdsComment}>
        <div className={classes.headerQuestionTitle}>
          <CommentIcon className={classes.headerQuestionIcon} />
          <Typography variant="subtitle2" className={classes.chartTitle}>
            {questionTitle}
          </Typography>
        </div>
        <List className={classes.root}>
          {listComments.map((comm, idx) => {
            const dataFormatted = moment(comm.date).format('hh:mm A - YYYY/MM/DD');
            return (
              <div key={idx}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={
                      <div className={classes.inlineComment}>
                        <Typography
                          variant="subtitle1"
                          color="textPrimary"
                          fontWeight="fontWeightBold"
                          className={classes.userComment}
                        >
                          {comm.userName}
                        </Typography>
                        <Typography
                          variant="caption"
                          className={classes.dateComment}
                          gutterBottom
                        >
                          {dataFormatted}
                        </Typography>
                      </div>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography component="span" variant="body2" color="textPrimary">
                          {comm.comment}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                {idx < listCommentsSize - 1 && <Divider component="li" />}
              </div>
            );
          })}
        </List>
      </Paper>
    </Grid>
  );
};

const AdsData = ({ classes, number, text }) => {
  return (
    <div>
      <div style={{ textAlign: 'center' }}>
        <Typography variant="h5">{number}</Typography>
      </div>
      <div>{text}</div>
    </div>
  );
};

const Ads = ({ classes, question }) => {
  const { questionTitle, totalViews, totalClicks, rateViews, rateClicks } = question;

  return (
    <Grid item className={classes.pieContainer}>
      <Paper className={classes.paperAdsComment}>
        <div className={classes.headerQuestionTitle}>
          <MonetizationOnIcon className={classes.headerQuestionIcon} />
          <Typography variant="subtitle2" className={classes.chartTitle}>
            {questionTitle}
          </Typography>
        </div>
        <Grid container spacing={1} className={classes.adsContainer}>
          <Grid item className={classes.adsData}>
            <AdsData classes={classes} number={totalViews} text={'total views'} />
            <AdsData classes={classes} number={rateViews + '%'} text={'rate views'} />
          </Grid>
          <Grid item className={classes.adsData}>
            <AdsData classes={classes} number={totalClicks} text={'total clicks'} />
            <AdsData classes={classes} number={rateClicks + '%'} text={'rate clicks'} />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

const RenderQuestions = ({ classes, title, data, filter }) => {
  return (
    <Paper className={classes.paperPieChart} elevation={0}>
      <Typography variant="subtitle1" className={classes.questionTitle}>
        {title}
      </Typography>
      <Grid container spacing={1}>
        {data.map((question, index) => {
          if (question.questionHasData) {
            const pieChart = (
              <PieChartAnalytics
                question={question}
                key={index}
                preview={false}
                filter={filter}
              />
            );
            const commentContent = (
              <Comment classes={classes} question={question} key={index} />
            );

            const adsContent = <Ads classes={classes} question={question} key={index} />;

            if (question.type === 'defaultQuestion') {
              return pieChart;
            } else if (question.type === 'comment') {
              return commentContent;
            } else if (question.type === 'ads') {
              return adsContent;
            }
          }

          return null;
        })}
      </Grid>
    </Paper>
  );
};

const getSuggestions = (value, listFields) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? listFields
    : listFields.filter(
        field => field.name.toLowerCase().slice(0, inputLength) === inputValue
      );
};

function renderSuggestion(suggestion) {
  return <span key={suggestion.id}>{suggestion.name}</span>;
}

const listFields = [
  {
    id: '1',
    name: 'Channel',
  },
  {
    id: '2',
    name: 'Event',
  },
  {
    id: '3',
    name: 'Interaction',
  },
  {
    id: '4',
    name: 'Question',
  },
  {
    id: '5',
    name: 'Trivia',
  },
  {
    id: '6',
    name: 'Prediction',
  },
  {
    id: '7',
    name: 'Picks',
  },
  {
    id: '8',
    name: `Scratch N'Win`,
  },
  {
    id: '9',
    name: 'Date',
  },
];

class OldAnalyticsHome extends React.Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      fieldInput: false,
      operatorInput: false,
      valueInput: false,
      questionInput: false,
      dateInput: false,
      picksInput: false,
      value: '',
      suggestions: [],
      suggestionsPredicate: [],
      suggestionsQuestion: [],
      sentence: {
        field: null,
        operator: null,
        question: null,
        value: null,
        picks: {},
      },
      date: null,
      showAnonymousUsers: true,
    };
  }

  handleSelectQuestion = event => {
    this.setState({
      questionSelected: event.target.value,
    });
  };

  handleSelectAnswer = (event, index) => {
    this.setState({
      answerSelected: event.target.value,
    });
    const questionName = _.get(this.state.questionSelected, 'name', null);
    const questionIndex = _.get(this.state.questionSelected, 'value', null);
    const answerText = _.get(event.target.value, 'text', null);
    const answerIndex = parseInt(index.key);
    if (questionName && answerText) {
      this.props.createCondition(
        'Question',
        null,
        { name: answerText, index: answerIndex },
        { name: questionName, index: questionIndex },
        null,
        null
      );
    }
    this.clearSentence();
  };

  QuestionBox = () => {
    const { classes, listQuestions } = this.props;
    const options = _.get(this.state.questionSelected, 'options', []);
    return (
      <div className={classes.containerFieldFilter}>
        <div className={classes.containerFormQuestion}>
          <FormControl className={classes.formControl}>
            <InputLabel>Question</InputLabel>
            <Select
              value={this.state.questionSelected || ''}
              onChange={this.handleSelectQuestion}
            >
              {listQuestions &&
                listQuestions.map((question, idx) => (
                  <MenuItem value={question} key={idx}>
                    {question.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel>Answer</InputLabel>
            <Select
              value={this.state.answerSelected || ''}
              onChange={(e, index) => this.handleSelectAnswer(e, index)}
              disabled={this.state.questionSelected ? false : true}
            >
              {options &&
                options.map((option, idx) => (
                  <MenuItem value={option} key={idx}>
                    {option.text}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
        <IconButton
          className={classes.deleteButton}
          aria-label="delete"
          size="small"
          onClick={() => this.handleDeleteNewCondition()}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    );
  };

  fieldInput = async () => {
    const { listConditions, updateListPredicates, fetchListQuestions } = this.props;
    let sentence = this.state.sentence;

    const condSize = listConditions.length;
    if (condSize >= 0 && condSize < 3) {
      sentence.field = listFields[condSize];
      sentence.operator = {
        id: 1,
        name: 'is',
      };
      this.setState({
        sentence: sentence,
        suggestions: [],
        suggestionsPredicate: [],
        suggestionsQuestion: [],
        operatorInput: false,
        valueInput: true,
        fieldInput: false,
        value: '',
      });
      updateListPredicates(sentence);
    } else if (condSize >= 3) {
      const previousCond = listConditions[condSize - 1];
      const previousType = _.get(previousCond, 'value.type', null);
      if (
        previousType === 'trivia' ||
        previousType === 'prediction' ||
        previousType === 'picks'
      ) {
        this.setState({
          sentence: sentence,
          suggestions: [],
          suggestionsPredicate: [],
          suggestionsQuestion: [],
          questionInput: true,
          questionSelected: null,
          optionSelected: null,
          value: '',
        });
        fetchListQuestions(previousCond.value._id);
      }
    }
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    // let listFields = this.props.listFields;

    this.setState({
      suggestions: getSuggestions(value, listFields),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
      value: '',
    });
  };

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  onSuggestionsFetchRequestedPredicate = ({ value }) => {
    let listPredicates = this.props.listPredicates;
    this.setState({
      suggestionsPredicate: getSuggestions(value, listPredicates),
    });
  };

  onSuggestionsClearRequestedPredicate = () => {
    this.setState({
      suggestionsPredicate: [],
      value: '',
    });
  };

  onSuggestionsFetchRequestedQuestion = ({ value }) => {
    let listQuestions = this.props.listQuestions;
    this.setState({
      suggestionsQuestion: getSuggestions(value, listQuestions),
    });
  };

  onSuggestionsClearRequestedQuestion = () => {
    this.setState({
      suggestionsQuestion: [],
      value: '',
    });
  };

  clearSentence = () => {
    let sentence = {
      field: null,
      operator: null,
      value: null,
      question: null,
      picks: {},
    };
    this.setState({
      sentence: sentence,
      fieldInput: false,
      operatorInput: false,
      valueInput: false,
      questionInput: false,
      dateInput: false,
      picksInput: false,
    });
  };

  handleConfirmTeamPicks = () => {
    const { field, value, question, picks } = this.state.sentence;
    if (field && value && question && picks) {
      this.props.createCondition(field.name, null, value, question, null, picks);
    }

    this.clearSentence();
  };

  handleDeleteNewCondition = () => {
    this.clearSentence();
  };

  setDateFilter = date => {
    this.setState({
      date: date,
    });
  };

  handleDateFilter = () => {
    const { field, operator } = this.state.sentence;
    if (field && operator && this.state.date) {
      this.props.createCondition(
        field.name,
        operator.name,
        null,
        null,
        this.state.date,
        null
      );
    }
    this.setState({
      dateInput: false,
      date: null,
    });
    this.clearSentence();
  };

  render() {
    const {
      classes,
      listConditions,
      createCondition,
      listUsersInteraction,
      listOperators,
      usersWeek,
      interactionStatistics,
      eventStatistics,
      usersRate,
      validInteractions,
      showAnonymousUsers,
      showDeletedUsers,
    } = this.props;

    const {
      value,
      suggestions,
      suggestionsPredicate,
      fieldInput,
      operatorInput,
      valueInput,
      questionInput,
      dateInput,
      picksInput,
    } = this.state;

    const customFilterActived =
      !showAnonymousUsers ||
      !showDeletedUsers ||
      this.props.fromDate ||
      this.props.untilDate;

    let lt = this.props.listUsersInteraction;
    if (customFilterActived) {
      if (!showAnonymousUsers) {
        lt = lt.filter(user => {
          return user.name;
        });
      }

      if (!showDeletedUsers) {
        lt = lt.filter(user => {
          return user.type !== 'deleted';
        });
      }

      if (this.props.fromDate) {
        lt = lt.filter(user => {
          return moment(user.createdAt).isAfter(this.props.fromDate);
        });
      }

      if (this.props.untilDate) {
        lt = lt.filter(user => {
          return moment(user.createdAt).isBefore(this.props.untilDate);
        });
      }
    }

    let componentStatistics = null;
    if (eventStatistics) {
      componentStatistics = (
        <EventAnalytics interactionStatistics={eventStatistics.interactions} />
      );
    }
    if (interactionStatistics && interactionStatistics.hasOwnProperty('data')) {
      componentStatistics = (
        <Grid item xs={12}>
          <RenderQuestions
            title={interactionStatistics.title}
            classes={classes}
            data={interactionStatistics.data}
            filter={this.props.filterOption}
          />
        </Grid>
      );
    }

    const cards = [
      {
        label: 'Users',
        data: _.size(listUsersInteraction),
        icon: UserIcon,
        color: '#FFA630',
        key: 'user',
      },
      {
        label: 'Users rate',
        data: usersRate + `%`,
        icon: '%',
        color: '#14A885',
        key: 'user_rate',
      },
      {
        label: 'New users since last week',
        data: usersWeek,
        icon: TrendingUpIcon,
        color: '#D7E8BA',
        key: 'new_users_week',
      },
      {
        label: 'Interactions',
        data: validInteractions,
        icon: LeadIcon,
        color: '#4DA1A9',
        key: 'interactions',
      },
    ];

    const getSuggestionValue = suggestion => {
      return suggestion.name;
    };

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: 'Type a field to filter',
      value,
      onChange: (form, { newValue, method }) => {
        this.setState({
          // value: event.newValue,
          value: method === 'click' || method === 'enter' ? '' : newValue,
        });
      },
    };

    const getSuggestionValuePredicate = suggestion => {
      let sentence = this.state.sentence;
      sentence.value = suggestion;
      this.setState({
        sentence: sentence,
        valueInput: false,
      });
      const { field, operator, value, question } = this.state.sentence;

      if (field && field.name !== 'Picks') {
        if (field && value && (operator || question)) {
          if (operator) {
            createCondition(field.name, operator.name, value, null, null, null);
          } else if (question) {
            createCondition(field.name, null, value, question, null, null);
          }
          this.clearSentence();
        }
      } else {
        this.setState({
          sentence: sentence,
          picksInput: true,
        });
      }

      return suggestion.name;
    };

    // Autosuggest will pass through all these props to the input.
    const inputPropsPredicate = {
      placeholder: 'Type a value',
      value,
      onChange: (form, { newValue, method }) => {
        this.setState({
          value: method === 'click' || method === 'enter' ? '' : newValue,
        });
      },
    };

    const clickOperator = index => {
      if (index >= 0 && index < listOperators.length) {
        let sentence = this.state.sentence;
        sentence.operator = listOperators[index];
        sentence.question = null;
        if (sentence.field.name === 'Date') {
          this.setState({
            sentence: sentence,
            operatorInput: false,
            dateInput: true,
          });
        } else {
          this.setState({
            sentence: sentence,
            operatorInput: false,
            valueInput: true,
          });
        }
      }
    };

    let report = null;
    const lastElem = _.last(listConditions);

    let reportFileName = `output.csv`;
    if (lastElem) {
      report = lastElem.field;
      reportFileName =
        `Report ${report} ` + _.get(lastElem, 'value.name', 'output') + `.csv`;
    }

    return (
      <div className={classes.content}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className={classes.headerAnalytics}>
              <Typography className={classes.title} variant="h6" gutterBottom>
                Lean In Moment<sup className={classes.sup}>TM</sup> Analytics
              </Typography>
              {report && report === 'Event' && (
                <CSVLink
                  className={classes.btnReport}
                  data={this.props.csvData}
                  filename={reportFileName}
                  onClick={() => {
                    this.props.createReport({});
                    // return false;
                  }}
                  target="_blank"
                >
                  <Button variant="contained" size="small" color="primary">
                    DOWNLOAD {report} REPORT
                  </Button>
                </CSVLink>
              )}
            </div>
            <Paper className={classes.paper} elevation={0}>
              <Typography className={classes.subtitle} variant="subtitle1" gutterBottom>
                Filter
              </Typography>
              <Grid container spacing={1}>
                <Condition
                  key={1}
                  field={'VERSUS'}
                  operator={''}
                  value={{ name: '' }}
                  // question={condition.question}
                  date={null}
                  // picks={condition.picks}
                  // indexCondition={index}
                  enableDelete={false}
                />
                {listConditions.map((condition, index) => {
                  let enableDelete = false;
                  const inputClosed =
                    !fieldInput &&
                    !operatorInput &&
                    !questionInput &&
                    !valueInput &&
                    !dateInput &&
                    !picksInput;
                  if (index === listConditions.length - 1 && inputClosed) {
                    enableDelete = true;
                  }
                  return (
                    <Condition
                      key={index}
                      field={condition.field}
                      operator={condition.operator}
                      value={condition.value}
                      question={condition.question}
                      date={condition.date}
                      picks={condition.picks}
                      indexCondition={index}
                      enableDelete={enableDelete}
                    />
                  );
                })}
                {fieldInput && (
                  <div className={classes.containerFieldFilter}>
                    <Autosuggest
                      name="field"
                      className={classes.inputUser}
                      suggestions={suggestions}
                      onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                      onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                      getSuggestionValue={getSuggestionValue}
                      renderSuggestion={suggestion => renderSuggestion(suggestion)}
                      inputProps={inputProps}
                      alwaysRenderSuggestions={true}
                    />
                    <IconButton
                      className={classes.deleteButton}
                      aria-label="delete"
                      size="small"
                      onClick={() => this.handleDeleteNewCondition()}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}
                {operatorInput && (
                  <div className={classes.containerFieldFilter}>
                    <div className={classes.selectOperatorContainer}>
                      <Typography variant="subtitle2">
                        {this.state.sentence.field.name}
                      </Typography>
                      <Paper className={classes.paperQuestion}>
                        <MenuList>
                          {listOperators.map((op, index) => (
                            <MenuItem key={op.id} onClick={() => clickOperator(index)}>
                              {op.name}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Paper>
                    </div>
                    <IconButton
                      className={classes.deleteButton}
                      aria-label="delete"
                      size="small"
                      onClick={() => this.handleDeleteNewCondition()}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}
                {questionInput && this.QuestionBox()}
                {dateInput && (
                  <div className={classes.containerFieldFilter}>
                    <div>
                      <div className={classes.selectValueContainer}>
                        {this.state.sentence.field && this.state.sentence.operator && (
                          <div>
                            <Typography variant="subtitle2">
                              {this.state.sentence.field.name}
                            </Typography>
                            <br />
                            {this.state.sentence.operator.name}
                          </div>
                        )}
                      </div>
                      <DatePicker
                        popperClassName={classes.calendar}
                        className={classes.dateFilter}
                        placeholderText="Click to select a date"
                        selected={this.state.date}
                        onChange={date => this.setDateFilter(date)}
                        onBlur={() => this.handleDateFilter()}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        timeCaption="time"
                        dateFormat="MMMM d, yyyy h:mm aa"
                        disabledKeyboardNavigation
                      />
                    </div>
                    <IconButton
                      className={classes.deleteButton}
                      aria-label="delete"
                      size="small"
                      onClick={() => this.handleDeleteNewCondition()}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}
                {valueInput && (
                  <div className={classes.containerFieldFilter}>
                    <div>
                      <div className={classes.selectValueContainer}>
                        {this.state.sentence.field && (
                          <div>
                            <Typography variant="subtitle2">
                              {this.state.sentence.field.name}
                            </Typography>
                            <br />
                            {this.state.sentence.operator &&
                              this.state.sentence.operator.name}
                            {this.state.sentence.question &&
                              this.state.sentence.question.name}
                          </div>
                        )}
                      </div>
                      <Autosuggest
                        name="value"
                        className={classes.inputUser}
                        suggestions={suggestionsPredicate}
                        onSuggestionsFetchRequested={
                          this.onSuggestionsFetchRequestedPredicate
                        }
                        onSuggestionsClearRequested={
                          this.onSuggestionsClearRequestedPredicate
                        }
                        getSuggestionValue={getSuggestionValuePredicate}
                        renderSuggestion={suggestion => renderSuggestion(suggestion)}
                        inputProps={inputPropsPredicate}
                        alwaysRenderSuggestions={true}
                      />
                    </div>
                    <IconButton
                      className={classes.deleteButton}
                      aria-label="delete"
                      size="small"
                      onClick={() => this.handleDeleteNewCondition()}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}
                {picksInput && (
                  <div className={classes.containerFieldFilter}>
                    <TextField
                      className={classes.teamInput}
                      label="Team 1"
                      onChange={event => {
                        let sentence = this.state.sentence;
                        sentence.picks['team1'] = event.target.value;
                        if (sentence.field.name === 'Picks') {
                          this.setState({
                            sentence: sentence,
                          });
                        }
                      }}
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      className={classes.teamInput}
                      label="Team 2"
                      onChange={event => {
                        let sentence = this.state.sentence;
                        sentence.picks['team2'] = event.target.value;
                        if (sentence.field.name === 'Picks') {
                          this.setState({
                            sentence: sentence,
                          });
                        }
                      }}
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <IconButton
                      className={classes.deleteButton}
                      aria-label="delete"
                      size="small"
                      onClick={() => this.handleDeleteNewCondition()}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      className={classes.deleteButton}
                      aria-label="delete"
                      size="small"
                      onClick={() => this.handleConfirmTeamPicks()}
                    >
                      <CheckIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}
                {!fieldInput &&
                  !operatorInput &&
                  !questionInput &&
                  !valueInput &&
                  !dateInput &&
                  !picksInput && (
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={() => this.fieldInput(listConditions)}
                    >
                      add condition
                    </Button>
                  )}
              </Grid>
            </Paper>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <div className={classes.filterDate}>
                  <FormControlLabel
                    style={{ float: 'right' }}
                    control={
                      <Checkbox
                        checked={!!showAnonymousUsers}
                        onChange={() => {
                          if (showAnonymousUsers) {
                            const users = this.props.listUsersInteraction.filter(user => {
                              return user.name;
                            });
                            this.props.setListUsersInteractionCustomFiltered(users);
                          }

                          this.props.setShowAnonymousUsers(!showAnonymousUsers);
                        }}
                        color="primary"
                      />
                    }
                    label="Show Anonymous Users"
                  />
                  <FormControlLabel
                    style={{ float: 'right' }}
                    control={
                      <Checkbox
                        checked={showDeletedUsers}
                        onChange={() => {
                          this.props.setShowDeletedUsers(!showDeletedUsers);
                        }}
                        color="primary"
                      />
                    }
                    label="Show Deleted Users"
                  />
                  <TextField
                    id="subscribed-from"
                    label="Subscribed from"
                    type="date"
                    value={this.props.fromDate}
                    className={classes.pickerDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={event => {
                      const date = event.target.value
                        ? moment(event.target.value).format('YYYY-MM-DD')
                        : '';

                      this.props.setFromDateFilterUser(date);
                    }}
                  />
                  <TextField
                    id="subscribed-until"
                    label="Subscribed until"
                    type="date"
                    value={this.props.untilDate}
                    className={classes.pickerDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={event => {
                      const date = event.target.value
                        ? moment(event.target.value).format('YYYY-MM-DD')
                        : '';

                      this.props.setUntilDateFilterUser(date);
                    }}
                  />
                </div>
                <Paper className={classes.paperTable} elevation={0}>
                  <DataList
                    listUsersInteraction={
                      !!customFilterActived ? lt : listUsersInteraction
                    }
                  />
                </Paper>
              </Grid>
              <Grid className={classes.gridCards} container>
                {cards.map((card, index) => {
                  let currentCondition = null;
                  let hideCard = false;

                  if (listConditions && listConditions.length) {
                    currentCondition = listConditions[listConditions.length - 1];

                    if (card.key === 'user_rate' || card.key === 'interactions') {
                      if (
                        currentCondition.field !== 'Event' &&
                        currentCondition.field !== 'Interaction'
                      ) {
                        hideCard = true;
                      }
                    }
                  } else {
                    if (card.key === 'user_rate' || card.key === 'interactions') {
                      hideCard = true;
                    }
                  }
                  return (
                    <CardData
                      key={index}
                      classes={classes}
                      label={card.label}
                      data={card.data}
                      AvatarIcon={card.icon}
                      color={card.color}
                      hide={hideCard}
                    />
                  );
                })}
              </Grid>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={1}>
                  {componentStatistics}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(OldAnalyticsHome);
